import { Application } from 'stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';
import configureStore from './store/configureStore';
import controllerSchema from './controller_schema';
import { loadUser } from './loadUser';
import { setApiParams } from './store/actions';

function createJC() {
  return {
    start: function start(_ref) {
      var key = _ref.key,
          url = _ref.url;
      var store = configureStore();
      store.dispatch(setApiParams({
        key: key,
        url: url
      }));
      var application = Application.start(document.documentElement, controllerSchema);
      application.store = store;
      application.api = {
        key: key,
        url: url
      };

      var context = require.context('./controller', true, /\.js$/);

      application.load(definitionsFromContext(context));
      loadUser(store);
    }
  };
}

export default createJC();